import request from '@/utils/request'


export function save(data) {
  return request({
    url: 'libKneeHurt/save',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: 'libKneeHurt/delete',
    method: 'post',
    data
  })
}

export function getPageList(data) {
  return request({
    url: 'libKneeHurt/getPageList',
    method: 'post',
    data
  })
}
